import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import style from './style.vue';
import BackGround from './backGround';
import Blank from './blank';
import IconMenu from './iconMenu';
import LabelClass from './labelClass';
import Member from './member';
import MiniPage from './miniPage';
import Order from './order';
import PageVideo from './pageVideo';
import Picture from './picture';
import Propagate from './propagate';
import Search from './search';
import ShowWindow from './showWindow';
import QiKanShowWindow from './qiKanShowWindow';
import WeiGroup from './weiGroup';
import Site from './site';
import Swiper from './swiper';
import TextEdit from './text';
import Vguider from './vGuider';
import VideoEdit from './video';
import HoverIcon from './hoverIcon';
import SellOutText from './sellOutText';
import ProductPicture from './productPicture';
import Guide from './guide';
import HotBg from './hotBg';
import HotAd from './hotAd';
import ShareConfig from './shareConfig';
import HotStyle from './hotStyle';
import AppHoverIcon from './appHoverIcon';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';

enum FieldType {
  backGround = 'BackGround',
  blank = 'Blank',
  Blank = 'Blank',
  iconMenu = 'IconMenu',
  LabelClass = 'LabelClass',
  member = 'Member',
  miniPage = 'MiniPage',
  order = 'Order',
  pageVideo = 'PageVideo',
  picture = 'Picture',
  Propagate = 'Propagate',
  search = 'Search',
  ShowWindow = 'ShowWindow',
  weiGroup = 'weiGroup',
  ShowWindowGroup = 'ShowWindow',
  QiKanShowWindow = 'QiKanShowWindow',
  Site = 'Site',
  Swiper = 'Swiper',
  text = 'TextEdit',
  vGuider = 'Vguider',
  video = 'VideoEdit',
  HoverIcon = 'HoverIcon',
  SellOutText = 'SellOutText',
  ProductPicture = 'ProductPicture',
  guide = 'Guide',
  HotAd = 'HotAd',
  HotStyle = 'HotStyle',
  HotBg = 'HotBg',
  ShareConfig = 'ShareConfig',
  AppHoverIcon = 'AppHoverIcon',
}

const ConfigList = [
  { fieldType: FieldType.backGround, title: '背景' },
  { fieldType: FieldType.blank, title: '辅助空白' },
  { fieldType: FieldType.Blank, title: '辅助空白' },
  { fieldType: FieldType.iconMenu, title: '图标导航' },
  { fieldType: FieldType.LabelClass, title: '分类导航' },
  { fieldType: FieldType.member, title: '入会及权益' },
  { fieldType: FieldType.miniPage, title: '页面设置' },
  { fieldType: FieldType.order, title: '订单中心' },
  { fieldType: FieldType.pageVideo, title: '视频' },
  { fieldType: FieldType.picture, title: '图片' },
  { fieldType: FieldType.Propagate, title: '图文广告' },
  { fieldType: FieldType.search, title: '商品搜索' },
  { fieldType: FieldType.ShowWindow, title: '商品橱窗' },
  { fieldType: FieldType.weiGroup, title: '多页橱窗' },
  { fieldType: FieldType.QiKanShowWindow, title: '期刊橱窗' },
  { fieldType: FieldType.Site, title: '商城页' },
  { fieldType: FieldType.Swiper, title: '店铺形象图' },
  { fieldType: FieldType.text, title: '文字标题' },
  { fieldType: FieldType.vGuider, title: '分销员申请' },
  { fieldType: FieldType.video, title: '视频' },
  { fieldType: FieldType.HoverIcon, title: '悬浮图标' },
  { fieldType: FieldType.SellOutText, title: '售罄文本配置' },
  { fieldType: FieldType.ProductPicture, title: '图片' },
  { fieldType: FieldType.guide, title: '小程序引导' },
  { fieldType: FieldType.HotBg, title: '背景图' },
  { fieldType: FieldType.HotAd, title: 'HOT页广告位' },
  { fieldType: FieldType.HotStyle, title: '展示方式' },
  { fieldType: FieldType.ShareConfig, title: '分享海报' },
  { fieldType: FieldType.AppHoverIcon, title: '悬浮图标' },
];
@Component({
  components: {
    BackGround,
    Blank,
    IconMenu,
    LabelClass,
    Member,
    MiniPage,
    Order,
    PageVideo,
    Picture,
    Propagate,
    Search,
    ShowWindow,
    QiKanShowWindow,
    WeiGroup,
    Site,
    Swiper,
    TextEdit,
    Vguider,
    VideoEdit,
    HoverIcon,
    SellOutText,
    ProductPicture,
    Guide,
    HotBg,
    HotAd,
    HotStyle,
    ShareConfig,
    AppHoverIcon,
  },
  mixins: [style],
})
export default class DisplayEdit extends Vue {
  @Prop({ default: 1 })
    themeCode: number;

  @Prop({ default: () => {} })
    value: ItemObject;

  @Prop({ default: () => [] })
    attrButeList: ItemArray;

  @Prop({ default: false })
    classAd: boolean;

  // 传递参数 key值为组件的fieldType
  @Prop({ default: () => {} })
    params: ItemObject;

  // 1 镜千-店铺 2 镜千-个人中心 3 镜千-微页面 4 镜千/云单-商详 5 镜千-hot 6 云单-商城页 7 云单-个人中心 8 云单(网点)-微页面 9 云单(网点组)-微页面 10 云单 hot
  @Prop()
    fromPage: number;

  @Prop({ default: false })
    disabled: boolean;

  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  @Prop({ default: 2 })
    mode: number;

  // 网点商品分类列表
  @Prop({ default: () => [] })
    siteClassList: ItemArray;

  data: ItemObject = {};

  saveflag = false;

  caseType = 1;

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n || {};
      this.$emit('input', this.data);
    }
  }

  @Watch('data', { deep: true })
  watchData(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.$emit('input', this.data);
    }
  }

  validateForm() {
    if (!(this.$refs[this.data.fieldType] as ElForm).$refs.form||this.data.fieldType === 'order') {
      return Promise.resolve(true);
    } else {
      if (this.data.fieldType === 'ShowWindowGroup') {
        return ((this.$refs[this.data.fieldType] as ElForm).$refs.formb as ElForm).validate();
      } else {
        return ((this.$refs[this.data.fieldType] as ElForm).$refs.form as ElForm).validate();
      }
    }
  }

  save() {
    this.validateForm().then((valid) => {

      const { message }= Functions.validateDisplayEditData(this.data, +this.mode===2)
      if (valid&&!message) {
        const { ygswpId, fieldType } = this.data;

        if (fieldType === 'member') {
          const checkList = (this.$store.state.brandList.brandList || []).filter(i => i.check);
          console.log(checkList);
          this.data.desc.brandGroupConfig.brandGroupList = checkList.map(i => i.code);
        }
        if (fieldType === 'Site' && this.data.desc && Array.isArray(this.data.desc)) {
          this.data.desc = {
            siteLogo: '',
          };
        }
        if (fieldType === 'guide' && this.data.desc && Array.isArray(this.data.desc)) {
          this.data.desc = {
            guideContent: '',
          };
        }
        if (fieldType === 'iconMenu') {
          const { type, margin, borderRadius, isDefault } = this.data.desc;
          this.data.desc = {
            type,
            margin,
            borderRadius,
            isDefault,
            list: this.data.desc.list || [],
          };
        }
        if (fieldType === 'LabelClass' && this.data.showClassType === 0) {
          this.data.desc.list = [];
        }

        if (fieldType === 'ShowWindow' || fieldType === 'ShowWindowGroup') {
          const { desc } = this.data;
          // 2021.3.31  何波和颜俊要求去掉productList
          if (desc && desc.productList) {
            delete desc.productList;
          }
          if (desc && desc.caseGroup) {
            desc.caseGroup = (desc.caseGroup || []).map((v) => {
              if (v.productList) {
                delete v.productList;
              }
              return v;
            });
          }
          !this.data.sgwpId && (this.data.sgwpId = 0);
          delete this.data.sgwcgId;
        }

        if (fieldType === 'QiKanShowWindow') {
          const { qiKanName, qiKanSize, qiKanType, qiKanNum, qiKanStyle, style, list } = this.data.desc;
          this.data.desc = {
            qiKanName,
            qiKanSize,
            qiKanType,
            qiKanNum,
            qiKanStyle,
            style,
            list: list || [],
          };
        }

        // 陈儒要求更改数据格式，直接改变动很大，所以取和提交时，数据转换一下
        if (fieldType === 'Propagate') {
          this.data.desc = {
            pName: this.data.desc.pName,
            pWidth: this.data.desc.pWidth,
            pHeight: this.data.desc.pHeight,
            pMaxPage: this.data.desc.pMaxPage,
            pStyle: this.data.desc.pStyle,
            displayType: this.data.desc.displayType,
            margin: this.data.desc.margin,
            borderRadius: this.data.desc.borderRadius,
            backGround: this.data.desc.backGround,
            list: this.data.desc.list || [],
            config: {
              pStyle: this.data.desc.pStyle,
              displayType: this.data.desc.displayType,
              margin: this.data.desc.margin,
              borderRadius: this.data.desc.borderRadius,
              backGround: this.data.desc.backGround,
            },
          };
        }
        const postParams = {
          ygswpId,
          fieldType: this.data.fieldType,
          desc: this.data.desc,
        };
        IPSService.componentContentSave({ postParams }).then((res) => {
          if (res && res.result) {
            this.$message.success('保存成功');
            this.saveflag = true;
            this.$emit('saveFlag', this.saveflag);
          } else {
            this.$message.error('保存失败');
          }
        });
      } else {
        this.$message.warning(message)
        return false;
      }
    });
  }

  renderConfigItem(h) {
    let configItem = <span></span>;
    if (Object.keys(FieldType).includes(this.data.fieldType)) {
      configItem = h(FieldType[this.data.fieldType], {
        props: {
          value: this.data,
          themeCode: this.themeCode,
          attrButeList: this.attrButeList,
          siteClassList: this.siteClassList,
          fromPage: this.fromPage,
          disabled: this.disabled,
          classAd: this.classAd,
          postParams: this.params ? this.params[FieldType.ShareConfig] : {},
        },
        on: {
          change: (val) => {
            this.$emit('change', val);
          },
        },
        ref: this.data.fieldType,
      });
    }
    return configItem;
  }

  renderNoSave(h) {
    return <span class="r-px-20 block r-mt-40">请先点击左下角【保存布局】按钮，对本新增装修组件的布局进行保存后，再编辑具体装修内容！</span>;
  }
  get dealPage(){
    console.log(this.fromPage)
    return this.fromPage&&(this.fromPage===1||this.fromPage===2)
  }
  render(h) {
    const type = ConfigList.find(v => v.fieldType === FieldType[this.data.fieldType]);
    const title = type ? (this.classAd ? '分类广告' : type.title) : '';
    const layout = this.data.ygswpId;
    return type ? (
      <div class={{ 'config-content height-100': true, 'relative-position r-ml-30': !(this.dealPage) }}>
        {[
          <div class="blockTitle config-title">{title}</div>,
          this.fromPage === 6 || this.fromPage === 7
            ? layout
              ? [
                this.renderConfigItem(h),
                <span class='hei-31 wid-196 block' />,
                <div style="box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);" class="fixed bottom-62 z-index-10 bg-white line-height-44 hei-22 no-top-border border-white wid-199">
                  <el-button class="r-ml-14" type="primary" onClick={this.save.bind(this)}>
                      保存
                  </el-button>
                </div>,
              ]
              : this.renderNoSave(h)
            : this.renderConfigItem(h),
        ]}
      </div>
    ) : (
      ''
    );
  }
}
